import gerade from './Gerade.woff';
import holli from './Holli.woff2';

export default [
  {
    name: 'Gerade',
    formats: [
      { format: 'woff', url: gerade }
    ]
  },
  {
    name: 'Holli',
    formats: [
      { format: 'woff2', url: holli }
    ]
  },
];
